"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openLocation = openLocation;
exports.openUrl = void 0;

var _genericFilehandle = require("generic-filehandle");

var _LocalFile = _interopRequireDefault(require("./LocalFile"));

var _rangeFetcher = require("./rangeFetcher");

var _tracks = require("../tracks");

var _util = require("../../util");

var openUrl = function openUrl(arg) {
  return (0, _rangeFetcher.openUrl)(arg);
};

exports.openUrl = openUrl;

function isUriLocation(location) {
  return 'uri' in location;
}

function isLocalPathLocation(location) {
  return 'localPath' in location;
}

function isBlobLocation(location) {
  return 'blobId' in location;
}

function openLocation(location) {
  if (!location) {
    throw new Error('must provide a location to openLocation');
  }

  if (isLocalPathLocation(location)) {
    if (!location.localPath) {
      throw new Error('No local path provided');
    }

    if (_util.isElectron || typeof jest !== 'undefined') {
      return new _LocalFile.default(location.localPath);
    } else {
      throw new Error("can't use local files in the browser");
    }
  }

  if (isUriLocation(location)) {
    if (!location.uri) {
      throw new Error('No URI provided');
    }

    return openUrl(location.baseUri ? new URL(location.uri, location.baseUri).href : location.uri);
  }

  if (isBlobLocation(location)) {
    // special case where blob is not directly stored on the model, use a getter
    var blob = (0, _tracks.getBlob)(location.blobId);

    if (!blob) {
      throw new Error("file (\"".concat(location.name, "\") was opened locally from a previous session. To restore it, go to track settings and reopen the file"));
    }

    return new _genericFilehandle.BlobFile(blob);
  }

  throw new Error('invalid fileLocation');
}